






































import Vue from 'vue'

import Notification from '@/groupBuy/components/requestList/Notification.vue'
import RequestItem from '@/groupBuy/components/requestList/RequestItem.vue'

import { State } from './store/state'
import { ActionTypes } from './store/type'
import {
  RequestItemModel
} from '@/groupBuy/types'
import service from '@/groupBuy/services'
import { MutationTypes } from '@/groupBuy/requestList/store/type'
import { SYSTEM_ERROR } from '@/common/constants'
import HowToRequest from '../components/HowToRequest.vue'

export default Vue.extend({
  components: {
    Notification,
    RequestItem,
    HowToRequest
  },
  data(): {
  } {
    return {
    }
  },
  computed: {
    storeState(): State {
      return this.$store.state
    },
    requestList(): RequestItemModel[] {
      return this.storeState.requestList
    },
    numberRequests(): number {
      return this.storeState.requestList.length
    }
  },
  created() {
    this.$store.dispatch(ActionTypes.INIT_DATA)
  },
  methods: {
    refreshInputSizeList(requestUuid: string) {
      service.refreshInputSizeList(requestUuid).then(res => {
        if (res) {
          const { groupBuyItem } = res
          if (groupBuyItem) {
            this.$store.commit(MutationTypes.UPDATE_REQUEST_INPUT_SIZE_LIST, {
              requestUuid: requestUuid,
              data: {
                groupBuyRequests: groupBuyItem.groupBuyRequests || [],
                amount: groupBuyItem.amount,
                sizeItems: groupBuyItem.sizeItems,
                quantity: groupBuyItem.quantity
              }
            })
          }
        }
      }).catch(() => {
        alert(SYSTEM_ERROR.UNKNOWN)
      })
    }
  }
})
